<template>
  <div class="card border-radius-none">
    <div class="columns is-marginless is-paddingless is-multiline card-article">
      <div class="column is-12 is-paddingless">
        <div v-if="!ligneCommande.referencePersonnalise ||
          sousLigne" class="card-article-input-icon">
          &nbsp;
        </div>
        <div v-else class="card-article-input-icon">
          <b-icon class="mgt-25px has-text-primary mgl-20px" icon="subdirectory-arrow-right">
          </b-icon>
        </div>
        <div class="card-article-input-product-large mgb-10px mgt-10px">
          <b-field :label="$t('detail.article.product')" :type="isEmpty"
            custom-class="is-size-7 is-marginless has-text-link">
            <b-autocomplete :placeholder="$t('detail.article.search')"
              v-model="search" :keep-first="keepFirst"
              :open-on-focus="openOnFocus" :data="produitsAutocomplete"
              :ref="'autocomplete_' + ligneCommande.ordre"
              field="title" @select="selectedProduct" @input="searchProduct()">
              <template slot="empty">
                <div v-if="fetched">{{ $t('detail.article.noResult') }}</div>
                <div v-else>{{ $t('detail.article.search') }}</div>
              </template>
              <template slot-scope="props">
                <div class="dropdown-item  is-paddingless" v-if="props.option.id">
                  <div class="columns is-marginless is-multiline">
                    <div class="column pdv-0">
                      <span class="has-text-weight-bold">
                        {{ props.option.title }}
                      </span>
                      <span v-if="props.option.titleEnfant">
                        &nbsp;➔&nbsp;{{ props.option.titleEnfant }}
                      </span>
                    </div>
                    <div class="column is-12 is-size-8 pdv-0 " v-if="props.option.adresse">
                      {{ importedFunction.adressFullStringGetter(props.option.adresse) }}
                    </div>
                  </div>
                </div>
                <div v-else class="dropdown-item is-disabled is-paddingless">
                  {{ $t(props.option.title) }}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
        <div class="card-article-input-libelle-remise mgb-10px">
          <b-field custom-class="is-size-7  has-text-link" :label="$t('detail.article.libelle')">
            <span>{{ ligneCommande.libelle }}
            </span>
          </b-field>
        </div>

        <div class="card-article-input-remise-soustotal">
          <div class="ellipsis card-article-input-price-remise float-right mgt-30px">
            &nbsp;
          </div>
        </div>

        <div class="card-article-input-remise-quantite">
          &nbsp;
        </div>

        <div class="float-right mgt-25px mgr-20px is-invisible">
          <b-icon icon="arrow-right-drop-circle" type="is-default">
          </b-icon>
        </div>
        <div class="has-text-weight-semibold mgt-30px float-right
          card-article-input-price-general right">
          <span v-if="ligneCommande.totalHt">
            {{ ligneCommande.totalHt | formatDevise }}
          </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce';
import {
  getAllProductDiversLocation,
  getAllProduitSponsoring,
  getAllProduitSalon,
  getAllProduitEncart,
  getAllProduitAutre,
} from '@/services/devisCommandes/getAllProduct';
import * as produitConf from '@/configuration/catalogue/produitConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  name: 'ligneNormaleProduit',
  props: {
    ligneCommande: Object,
    ligneRegroupement: Object,
    typeProduit: String,
    sousLigne: {
      type: Boolean,
      default: false,
      required: false,
    },
    sens: {
      type: String,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      fetched: false,
      search: null,
      keepFirst: false,
      openOnFocus: true,
      produitsAutocomplete: [],
      categoriesVenteAutorisees: [
        produitConf.CATEGORIE_LOCATION,
        produitConf.CATEGORIE_DIVERS,
        produitConf.CATEGORIE_PRESTATION,
        produitConf.CATEGORIE_DISPOSITIF,
      ],
      searchInMounted: false,
      importedFunction: {
        adressFullStringGetter,
      },
    };
  },
  computed: {
    isEmpty() {
      return this.ligneCommande.produitId ? '' : 'is-danger';
    },
  },
  mounted() {
    if (this.ligneCommande.referenceRegroupement) {
      this.categoriesVenteAutorisees = [produitConf.CATEGORIE_DIVERS];
    }
    if (this.typeProduit === produitConf.CATEGORIE_SPONSORING) {
      this.categoriesVenteAutorisees = [
        produitConf.CATEGORIE_PRESTATION,
        produitConf.CATEGORIE_DIVERS,
      ];
    }
    if (this.ligneCommande.produit) {
      this.searchInMounted = true;
      if (this.ligneCommande.typeProduit === produitConf.CATEGORIE_LOCATION) {
        this.categoriesVenteAutorisees = [produitConf.CATEGORIE_LOCATION];
      }
      this.search = this.ligneCommande.produit.reference;
    }
  },
  methods: {
    selectedProduct(option) {
      if (option) {
        if (!option.id) {
          this.$refs['autocomplete_' + this.ligneCommande.ordre].setSelected(null);
          return;
        }
        this.ligneCommande.produitId = option.id;
      }
    },
    searchProduct: debounce(async function searchProductC() {
      if (this.searchInMounted) {
        this.searchInMounted = false;
        return;
      }
      if (this.search
        && this.search.length >= 3) {
        this.fetched = true;
        let produits = [];
        switch (this.typeProduit) {
          case produitConf.CATEGORIE_SPONSORING:
            produits = await getAllProduitSponsoring(
              this.search,
              this.ligneRegroupement,
            );
            break;
          case produitConf.CATEGORIE_SALON:
            produits = await getAllProduitSalon(
              this.search,
              this.ligneRegroupement,
            );
            break;
          case produitConf.CATEGORIE_PRESSE:
            produits = await getAllProduitEncart(
              this.search,
              this.ligneRegroupement,
            );
            break;
          case produitConf.CATEGORIE_AUTRE:
            produits = await getAllProduitAutre(
              this.search,
              this.ligneRegroupement,
            );
            break;
          default:
            break;
        }
        const produitsDivers = await getAllProductDiversLocation(
          this.search,
          this.categoriesVenteAutorisees,
          this.societeId,
          this.sens,
        );
        this.produitsAutocomplete.push(...produits, ...produitsDivers);
      } else {
        this.produitsAutocomplete = [];
        this.fetched = false;
      }
    }, 500),
  },
};
</script>
